import { ViewModesContext } from 'components'
import { useContext } from 'react'

export function useViewMode() {
  return useContext(ViewModesContext)
}
